// @flow
import {groupBy, propOr} from 'ramda'
import Value from '../ui/Value'

const groupObjects = groupBy(({databaseId}) => databaseId || String(Math.random()))

function pickChildrenOfType(type: string, command: Object): any {
  const {children = []} = command

  return children.filter((c) => c.type.endsWith(type))
}

function makeValue(nextObj: Object, prevObj: ?Object): Value {
  const prevValue = propOr(nextObj.description, 'description', prevObj)
  const isNew = nextObj.type?.startsWith('Create') || false
  const isDeleted = nextObj.type?.startsWith('Destroy') || nextObj.destroy || false
  const isProtected = propOr(nextObj.isProtected, 'isProtected', prevObj)

  return new Value(
    isNew ? '' : prevValue,
    isDeleted ? prevValue : nextObj.description,
    {
      databaseId: nextObj.databaseId,
      isNew,
      isDeleted,
      isProtected,
    },
  )
}

function makeValues(
  existingChildren: $ReadOnlyArray<Object>,
  commandChildren: $ReadOnlyArray<Object>,
): $ReadOnlyArray<Value> {
  const grouped = groupObjects(commandChildren.concat(existingChildren))

  // $FlowFixMe[incompatible-type]
  return Object.values(grouped).map((pair) => makeValue(...pair))
}

export {
  makeValue,
  makeValues,
  pickChildrenOfType,
}
